/* COR.E – show price for partial variant selection */
(function () {
  if (window.coreGroupPriceLoaded) return;
  window.coreGroupPriceLoaded = true;

  function getSelected(form) {
    var fieldsets = form.querySelectorAll('variant-picker .option-selector');
    var selected = [];
    var count = 0;
    fieldsets.forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-index'), 10) - 1;
      var value = null;
      var checked = fs.querySelector('input.js-option:checked');
      if (checked) {
        value = checked.value;
      } else {
        var select = fs.querySelector('select');
        if (select && select.value) value = select.value;
      }
      selected[idx] = value;
      if (value !== null) count++;
    });
    return { values: selected, count: count, total: fieldsets.length };
  }

  function update(form) {
    var dataEl = form.querySelector('script.core-price-data');
    var priceEl = form.querySelector('.product-info__price .price__current');
    if (!dataEl || !priceEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var sel = getSelected(form);
    // Nothing selected, or full selection: the theme handles it
    if (sel.count === 0 || sel.count === sel.total) return;

    var matches = data.variants.filter(function (v) {
      return sel.values.every(function (val, i) {
        return val === null || val === undefined || v.options[i] === val;
      });
    });

    var pool = matches.filter(function (v) { return v.available; });
    if (!pool.length) pool = matches;
    if (!pool.length) return;

    var min = pool[0];
    var maxPrice = pool[0].price;
    pool.forEach(function (v) {
      if (v.price < min.price) min = v;
      if (v.price > maxPrice) maxPrice = v.price;
    });

    var oldFrom = priceEl.querySelector('.price__from');
    if (oldFrom) oldFrom.remove();

    var amountEl = priceEl.lastElementChild;
    if (!amountEl || amountEl.classList.contains('js-label')) return;
    amountEl.innerHTML = min.priceFormatted;

    if (min.price !== maxPrice) {
      var fromEl = document.createElement('span');
      fromEl.className = 'price__from';
      fromEl.textContent = data.fromLabel;
      priceEl.insertBefore(fromEl, amountEl);
      priceEl.insertBefore(document.createTextNode(' '), amountEl);
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('variant-picker input.js-option, variant-picker select')) return;
    var form = e.target.closest('.product-form');
    if (!form) return;
    setTimeout(function () { update(form); }, 0);
  });
})();